// extracted by mini-css-extract-plugin
export default {"root":"Input_root__Po2vT","input--sm":"Input_input--sm__A34Ev","input--lg":"Input_input--lg__sseO3","iconAfter":"Input_iconAfter__abusV","withLabel":"Input_withLabel__q+KEn"};